import { apiClientV1, apiAuthClientV1 } from './apiClient';

export default {
  signIn: (params) => apiAuthClientV1.post('/oauth/authorize', { ...params }),
  logOut: () => apiClientV1.post('/oauth/logout', {}),
  sessionCheck: () => apiClientV1.get('/oauth/check-session'),
  forgotRequestPassword: (params) => apiClientV1.post('/oauth/forgot-request', { ...params }),
  resetPassword: (resetHash, params) => apiClientV1.post(`/oauth/forgot-password/${resetHash}`, { ...params }),
  createPassword: (resetHash, params) => apiClientV1.post(`/oauth/create-password/${resetHash}`, { ...params }),
  checkCreatePasswordHashExpiration: (resetHash) => apiClientV1.get(`/oauth/check-set-password-expiration/${resetHash}`),
  checkIntegrationAvailability: (params) => apiClientV1.get('/oauth/check-integration-availability', { params }),
  resendUpdatePasswordEmail: (resetHash) => apiClientV1.get(`/oauth/resend-update-password-email/${resetHash}`),
  createPasswordLink: (params) => apiClientV1.post('/oauth/create-password-link', { ...params }),
  createDevice: (params) => apiClientV1.post('/oauth/create-device', { ...params }),
  getSsoConfiguration: (params) => apiAuthClientV1.post('/oauth/saml/check', { ...params }),
  getSsoPropertiesData: (requestId) => apiAuthClientV1.get(`/oauth/saml/data/${requestId}`),
  verifyMfa: (params) => apiAuthClientV1.post('/oauth/mfa/verify', { ...params }),
  resendMfaCode: (params) => apiAuthClientV1.post('/oauth/mfa', { ...params })
};
